import Lottie from "lottie-react";
import { Stack } from "@mui/material";
import loader from "@/components/page-loading/assets/bitelink-loader.json";

const PageLoading = () => {
    return (
        <Stack flex={1} justifyContent="center" alignItems="center" padding={3} height="100%">
            <div style={{ width: 125, height: 125 }}>
                <Lottie animationData={loader} loop={true} />
            </div>
        </Stack>
    )
}

export default PageLoading;
